/* eslint-disable */

interface MerchantData {
    country: string;
    merchantId: string;
    merchantGroupId: string;
    currency: string;
}


//const staticMidMatrix = "INDONESIA#mvci_asia_usd_sfmkt#C7819807-4947-446B-B160-E688FE49F9AS#USD,UNITED ARAB EMIRATES#mvci_euro_usd_sfpre#C7819807-4947-446B-B160-E688FE49F9EU#USD,UAE#mvci_euro_usd_sfpre#C7819807-4947-446B-B160-E688FE49F9EU#USD,AUSTRALIA#mvci_asia_usd_sfmkt#C7819807-4947-446B-B160-E688FE49F9AS#USD,FRANCE#mvci_euro_usd_sfpre#C7819807-4947-446B-B160-E688FE49F9EU#USD,THAILAND#mvci_asia_usd_sfmkt#C7819807-4947-446B-B160-E688FE49F9AS#USD,SINGAPORE#mvci_asia_usd_sfmkt#C7819807-4947-446B-B160-E688FE49F9AS#USD";
/*export const Mid: MerchantData[] = [
    { country: 'INDONESIA', merchantId: mid_asia, merchantGroupId: mgid_asia, currency: 'USD' },
    { country: 'UNITED ARAB EMIRATES', merchantId: mid_me, merchantGroupId: mgid_me, currency: 'USD' },
    { country: 'AUSTRALIA', merchantId: mid_asia, merchantGroupId: mgid_asia, currency: 'USD' },
    { country: 'FRANCE', merchantId: mid_me, merchantGroupId: mgid_me, currency: 'USD' },
    { country: 'THAILAND', merchantId: mid_asia, merchantGroupId: mgid_asia, currency: 'USD' },
    { country: 'SINGAPORE', merchantId: mid_asia, merchantGroupId: mgid_asia, currency: 'USD' },
];*/

const midMatrix = process.env.REACT_APP_INTL_MID_MATRIX || '';
const MidArr: MerchantData[] = midMatrix.split(',').map((entry: any) => {
    const [country, merchantId, merchantGroupId, currency] = entry?.split('#');
    return {
        country: country.replace(/_/g, ' '),
        merchantId,
        merchantGroupId,
        currency
    };
});

export function getMerchantIdByCountry(country?: string): string {
    if (!country || country.trim() === '') {
        return '';
    }

    const upperCountry = country.trim().toUpperCase();
    const merchant = MidArr.find(entry => entry.country === upperCountry);

    return merchant ? merchant.merchantId : '';
}
export function getMerchantGroupIdByCountry(country?: string): string {
    if (!country || country.trim() === '') {
        return '';
    }

    const upperCountry = country.trim().toUpperCase();
    const merchant = MidArr.find(entry => entry.country === upperCountry);

    return merchant ? merchant.merchantGroupId : '';
}
